import { render } from "./App.vue?vue&type=template&id=5d6dfb75"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5d6dfb75&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__